import SideBar from "../components/sideBar";
import translateText, { currentLanguage } from "../signals/language.signal";
import OfferImg from "../assets/logo_old.png";
import {
  CommissionsPolicy,
  fetchCommissionsPolicy,
} from "../signals/couponsData.signal";
import { useEffect } from "react";
import LazyImage from "../components/LazyImage";
const TermsAndConditions = () => {
  useEffect(() => {
    // couponsType.value = "";
    const fetchData = async () => {
      try {
        const result = await fetchCommissionsPolicy();
        CommissionsPolicy.value = result;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <div
      id="AboutUs"
      className="align-items-sm-center d-flex  justify-content-center flex-column w-100"
    >
      <div
        className=" loginContaner position-relative mb-1 p-3  w-100  text-center  rounded-3 "
        style={{ textAlign: "justify" }}
      >
        <SideBar
          more={true}
          showAccount={true}
          title={translateText(currentLanguage.value, "TermsAndConditions")}
        />
        {CommissionsPolicy.value ? (
          <div>
            <h1>سياسة العمولة</h1>
            <LazyImage src={OfferImg} alt="logo" className="mb-4 mt-4 w-100" />
            <p style={{ textAlign: "justify" }} className="m-0">
              يهدف نظام العمولة "مكافأة" الى مكافأة العملاء المخلصين و الاحتفاظ
              بهم خلال تقديم امتيازات و مكافات على عملايات الشراء ، و تعزيز
              علاقات العملاء مع الشركة وزيادة رضاهم.
            </p>
            <p style={{ textAlign: "justify" }} className="mt-3 mb-3">
              شروط و أحكام
            </p>
            <ul
              style={{ textAlign: "justify", listStylePosition: "inside" }}
              className="p-0"
            >
              <li>
                الأهلية: يمكن المشاركة في نظام العمولة "مكافأة" لأي عميل يمتلك
                حساب سارياً لدى الشركة.
                <ul style={{ textAlign: "justify" }}>
                  <li>
                    التسجيل: يجب على العملاء التسجيل في نظام العمولة "مكافأة"
                    للحصول على العمولة من خلال التسجيل في الموقع الالكتروني
                    للشركة.
                  </li>
                </ul>
              </li>
              <li>
                اكتساب العمولة: يمكن للعملاء اكتساب العمولة من خلال عمليات
                الشراء التي تتم عبر الموقع الإلكتروني أو الاتصال على مركز أتصال
                الشركة كما يمكنهم اكتساب العمولة من خلال الطلب المباشر من إدارة
                البيع (مندوبي، و مشرفي، و مدراء مبيعات).
              </li>
              <li>
                العروضات و الخصوم الخاصة: لا تحسب العمولة على العروض الخاصة و
                العروض الترويجية و المناقصات و المشاريع التي تتقدم بها الشركة
              </li>
              <li>المبيعات الآجلة: لا تحسب العمولة على المبيعات الآجلة.</li>
              <li>
                صلاحية العمولة: تنتهي صلاحية العمولة بعد 30 يوماً من تاريخ
                اكتسابها.{" "}
              </li>
              <li>تحسب العمولات وفقا للشرائح و الشروط التالية:</li>
              <table className="w-100 table-bordered text-center">
                <thead>
                  <tr>
                    <th>الشريحة</th>
                    <th>الشروط</th>
                    <th>نسبة العمولة</th>
                  </tr>
                </thead>
                <tbody>
                  {CommissionsPolicy.value.map((data, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        الاتقل اجمالي صافي قيمة المشتريات من{" "}
                        {data.SALES_FR_AMOUNT} - {data.SALES_TO_AMOUNT} ريال
                      </td>
                      <td>
                        {data.COMM_PERC}
                        {" %"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <h6>
                تحتفظ الشركة بالحق في تعديل سياسة نظام العمولة "مكافأة" في أي
                وقت و دون اي إشعار مسبق.{" "}
              </h6>
              <p style={{ textAlign: "justify" }} className="mt-3 mb-3">
                التواصل
              </p>
              <li>
                يمكن للعملاء التواصل مع الشركة للحصول على مزيد من المعلومات حول
                نظام العمولة "مكافأة" أو لتقديم ملاحظات من خلال الموقع
                الإلكتروني أو الاتصال بخدمة العملاء.{" "}
              </li>
              <p style={{ textAlign: "justify" }} className="mt-3 mb-3">
                المسؤوليات
              </p>
              <li>
                {" "}
                مسؤولية العميل: يتحمل العميل مسؤولية الاطلاع على سياسة نظام
                العمولة "مكافأة" وفهمها قبل المشاركة في نظام العمولات "مكافأة"
              </li>
              <li>
                مسؤولية الشركة: تلتزم الشركة بتقديم المكافآت وفقا لسياسة نظام
                العمولة "مكافأة"
              </li>
              <p style={{ textAlign: "justify" }} className="mt-3 mb-3">
                الحالات الخاصة
              </p>
              <li>
                لإرجاع والاستبدال و الالغاء: في حالة إرجاع أو استبدال منتج، سيتم
                خصم القيمة من العمولات التي تم اكتسابها مقابل ذلك المنتج من حساب
                العميل.{" "}
              </li>
              <li>
                الطلبات المعلقة: لن يتم احتساب العمولة المكتسبة مقابل الطلبات
                المعلقة حتى يتم شحن الطلب وتأكيد استلامه و استلام قيمتة من قبل
                العميل.{" "}
              </li>
              <li>
                الطلبات الملغاة: سيتم حسم العمولة المكتسبة مقابل الطلبات
                الملغاة.
              </li>
              <p style={{ textAlign: "justify" }} className="mt-3 mb-3">
                الصرف
              </p>
              <li>
                صرف العمولة: نقدا عبر نظام الكوبون الالكتروني coupon-e المسجل
                فيه العميل و تحسب من فاتورة الشراء للعميل على ً تصرف العمولة ان
                لا يزيد قيمة العمولة المنصرفة عن %50 من قيمة فاتورة مشترياته
                المراد خصمها.{" "}
              </li>
            </ul>
          </div>
        ) : (
          <div className="pt-4">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map(
              (index) => (
                <div
                  key={index}
                  className="align-items-sm-center d-flex justify-content-center w-100 mb-1"
                >
                  <div className="align-items-sm-center loginContaner d-flex justify-content-center w-100">
                    <div
                      style={{ height: "8.88px" }}
                      className="skeleton p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
                    ></div>
                  </div>
                </div>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TermsAndConditions;
